<template>
  <div class="c-apply">
    <sheet maxWidth="400">
      <h3 class="story-title">{{ lessonData.title }}</h3>
      <lesson-info :lessonData="lessonData" :bg="false" />

      <p class="select-baby" v-if="babyBriefOptions.length > 1">
        選擇早產兒寶寶資料<span class="select-baby__multiple">（可複選）</span>：
      </p>
      <pr-group-checkbox
        v-model:value="enrollBaby"
        :options="babyBriefOptions"
        multiple
        v-if="babyBriefOptions.length > 1"
      />

      <!-- v-show="showOtherBabyField" -->
      <Form :validation-schema="schema" @submit="onSubmit">
        <div class="form-wrap">
          <!-- <apply-other-baby-form ref="applyOtherBabyForm" /> -->

          <template  v-if="enrollBaby.includes('other')">
            <pr-form-item label="*早產兒寶寶姓名：">
              <pr-input v-model="form.otherBabyName" placeholder="請輸入寶寶的姓名" name="otherBabyName" />
            </pr-form-item>
            <pr-form-item label="*預產期：">
              <pr-input
                v-model="form.otherBabyPredictBirthDate"
                placeholder="2022-01-01"
                name="otherBabyPredictBirthDate"
                :inputFormat="dateInputFormat"
              />
            </pr-form-item>
            <pr-form-item label="*出生日期：">
              <pr-input
                v-model="form.otherBabyBirthday"
                placeholder="2022-01-01"
                name="otherBabyBirthday"
                :inputFormat="dateInputFormat"
              />
            </pr-form-item>
            <pr-form-item label="*出生醫院：">
              <pr-input v-model="form.otherBabyHospital" placeholder="" name="otherBabyHospital" />
            </pr-form-item>

            <pr-form-item-wrap left="1" right="1">
              <template v-slot:left>
                <pr-form-item label="*出生週數：" :mt="false">
                  <pr-input-number v-model="form.otherBabyBornWeek" name="otherBabyBornWeek" />
                </pr-form-item>
              </template>
              <template v-slot:right>
                <!-- label-desc="(公克)" -->
                <pr-form-item label="*出生體重（g）：" :mt="false">
                  <pr-input-number
                    v-model="form.otherBabyBornWeight"
                    name="otherBabyBornWeight"
                    step="100"
                    type="number"
                  />
                </pr-form-item>
              </template>
            </pr-form-item-wrap>
            </template>
        </div>

        <divide mt="60" />

        <p class="parent">家長姓名： {{ memberInfo.realname }}</p>
        <p class="email">
          Email : <span class="email__text">{{ memberInfo.email }}</span>
        </p>

        <div class="form-wrap">
          <pr-form-item label="*電話：">
            <pr-input v-model="form.mobile" placeholder="請輸入手機" name="mobile" />
          </pr-form-item>
          <pr-form-item label="*方便聯絡時間：">
            <!-- <pr-input v-model="form.contactTime" placeholder="請輸入真實姓名" name="contactTime" /> -->

            <pr-group-checkbox
              v-model:value="form.contactTime"
              :options="contactTimeOptions"
              inline
              name="contactTime"
            />
          </pr-form-item>

          <pr-form-item-wrap left="1" right="1" label="*參加人數：">
            <template v-slot:left>
              <pr-form-item label="成人" :mt="false">
                <pr-input-number v-model="form.adult" name="adult" type="number" />
              </pr-form-item>
            </template>
            <template v-slot:right>
              <pr-form-item label="小朋友" label-desc="(包含早產兒)" :mt="false">
                <pr-input-number v-model="form.children" name="children" type="number" />
              </pr-form-item>
            </template>
          </pr-form-item-wrap>
          <pr-form-item label="備註：">
            <pr-input v-model="form.memo" placeholder="" name="memo" />
          </pr-form-item>

          <pr-form-item submit>
            <pr-button @click="onSubmit" :disabled="isDisabled" width="100%">送出</pr-button>
          </pr-form-item>

          <div class="to-page" @click="toPreviousPage">
            <p class="to-page__previous">返回前頁</p>
          </div>
        </div>
      </Form>
    </sheet>
  </div>
</template>
<script>
import { defineComponent, ref, computed, reactive, h, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs';
import { Form } from 'vee-validate';
import LessonInfo from '@/components/News/LessonInfo.vue';
import { getIndexEventsAPI, parentApplyAPI } from '@/api/events';
import { useSiteStore } from '@/store/site';
import { identificationMapping } from '@/config/identificaitionConfig';
import yup from '@/utils/yup';
import errMsg from '@/utils/yup/yupCustomErrMsg';
import PrFormItem from '@/components/Form/PrFormItem.vue';
import PrFormItemWrap from '@/components/Form/PrFormItemWrap.vue';
import PrInput from '@/components/Form/PrInput.vue';
import PrInputNumber from '@/components/Form/PrInputNumber.vue';
import PrGroupCheckbox from '@/components/Form/PrGroupCheckbox/index.vue';
import Divide from '@/components/Global/Divide.vue';
import BabyBrief from '@/components/News/BabyBrief.vue';
import PrButton from '@/components/Global/PrButton.vue';
import useRequest from '@/hooks/useRequest';
import useAsyncDialog from '@/hooks/useAsyncDialog';
// import ApplyOtherBabyForm from '@/components/News/ApplyOtherBabyForm.vue';
import { statusMapping, applyStatusType } from '@/config/applyStatus';
import ApplySuccess from '@/components/News/ApplySuccess.vue';
import dateInputFormat from '@/utils/dateInputFormat';
import { getMemberInfoAPI } from '@/api/members';

export default defineComponent({
  name: 'Apply',
  components: {
    LessonInfo,
    Form,
    PrFormItem,
    PrFormItemWrap,
    PrButton,
    PrGroupCheckbox,
    PrInput,
    PrInputNumber,
    // PrSelect,
    Divide,
    // ApplyOtherBabyForm,
  },
  setup() {
    const siteStore = useSiteStore();
    const route = useRoute();
    const lessonData = ref({});
    const memberInfo = computed(() => siteStore.memberInfo);
    const enrollBaby = ref([]);
    const router = useRouter();
    const babyBriefOptions = ref([]);
    const babyIdDataMapping = ref();
    // const applyOtherBabyForm = ref(null);
    const { asyncDialog } = useAsyncDialog();
    const isDisabled = ref();

    const getBaby = async () => {
      siteStore.setIsLogin(true);
      const {
        status: getMemberInfoStatus,
        result: memberInfoResult,
      } = await getMemberInfoAPI();

      if (getMemberInfoStatus) {
        siteStore.setMemberInfo(memberInfoResult);
      }
    };

    getBaby();

    const contactTimeOptions = [
      {
        label: '上午：8-12',
        value: '上午',
      },
      {
        label: '下午：13-17',
        value: '下午',
      },
    ];

    const { response, request } = useRequest(getIndexEventsAPI);
    request({ uuid: route.query.id });

    const form = reactive({
      mobile: '',
      contactTime: [],
      adult: '1',
      children: '0',
      memo: '',

      otherBabyName: '',
      otherBabyPredictBirthDate: '',
      otherBabyBirthday: '',
      otherBabyHospital: '',
      otherBabyBornWeek: 0,
      otherBabyBornWeight: 0,
    });

    const validYds = (value) => {
      const ydsRegexp = /[0-9]{4}-[0-9]{2}-[0-9]{2}/;

      return ydsRegexp.test(value);
    };

    const validPostiveNumber = (value) => {
      if (value === '') return false;
      if (Number(value) < 0) return false;

      return true;
    };

    const beforeCheckFn = () => {
      console.log('...', enrollBaby.value.includes('other'));
      return enrollBaby.value.includes('other');
    };

    const schema = yup.object().shape({
      mobile: yup
        .string()
        .taiwanMobile({ errMsg: errMsg.taiwanMobile })
        .required(errMsg.required('手機'))
        .max(10, errMsg.max(10)),
      contactTime: yup.array().groupCheckboxList({ errMsg: errMsg.required('方便聯絡時間', 'select') }),
      adult: yup.string().enrollMembers({ errMsg: errMsg.enrollMembers }),
      // children: yup.string().enrollChildren({ errMsg: errMsg.enrollMembers }),
      otherBabyName: yup.string().validateBefore({ errMsg: errMsg.required('姓名'), beforeCheckFn }),
      otherBabyPredictBirthDate: yup
        .string()
        .validateBefore({ errMsg: errMsg.required('預產期'), validateFn: validYds, beforeCheckFn }),
      otherBabyBirthday: yup
        .string()
        .validateBefore({ errMsg: errMsg.required('出生日期'), validateFn: validYds, beforeCheckFn }),
      otherBabyHospital: yup.string().validateBefore({ errMsg: errMsg.required('醫院'), beforeCheckFn }),
      // otherBabyBornWeek: yup.string().bornWeek({ errMsg: errMsg.bornWeek }).required(errMsg.required('出生週數')),
      otherBabyBornWeek: yup
        .string()
        .validateBefore({ errMsg: errMsg.required('出生週數'), validateFn: validPostiveNumber, beforeCheckFn }),
      // otherBabyBornWeight: yup.string().bornWeight({ errMsg: errMsg.bornWeight }).required(errMsg.required('出生體重')),
      otherBabyBornWeight: yup
        .string()
        .validateBefore({ errMsg: errMsg.required('出生體重'), validateFn: validPostiveNumber, beforeCheckFn }),
    });

    const getIndexEvents = async (res) => {
      try {
        const formatArticle = {
          ...res.value.result,
          formatPublished: dayjs(res.value.result.published).format('YYYY-MM-DD'),
          formatEventStartTime: dayjs(res.value.result.event_start_time).format('YYYY-MM-DD HH:mm'),
          formatEventEndTime: dayjs(res.value.result.event_end_time).format('YYYY-MM-DD HH:mm'),
          formatApplyStartTime: dayjs(res.value.result.apply_start_date).format('YYYY-MM-DD HH:mm'),
          formatApplyEndTime: dayjs(res.value.result.apply_end_date).format('YYYY-MM-DD HH:mm'),
        };

        const status = applyStatusType(res.value.result);

        if (status !== 'available') {
          asyncDialog({
            desc: statusMapping[status],
            callback: () => {
              router.push({
                name: 'activity-lessons',
              });
            },
          });
        }

        lessonData.value = formatArticle;
      } catch (e) {
        console.log('e', e);
      }
    };

    const onOtherBabbySubmit = (values) => {
      console.log('onOtherBabbySubmit', JSON.stringify(values, null, 2));
    };

    // const onSubmit = (values) => {
    //   console.log('form', JSON.stringify(values, null, 2));
    // };

    const onSubmit = async (values) => {
      console.log('form', JSON.stringify(values, null, 2));

      const isValid = await schema.isValid(form);
      isDisabled.value = isValid;
      // console.log('isValid', isValid);
      if (!isValid) return;

      try {
        if (!enrollBaby.value.length) {
          asyncDialog({
            desc: '請至少選擇一名早產兒寶寶，或點選其他早產兒寶寶並填寫資料',
          });
          return;
        }
        const enrollBabyList = [];
        enrollBaby.value.forEach((id) => {
          if (id !== 'other') {
            enrollBabyList.push(babyIdDataMapping.value[id]);
          }
        });

        let applyOtherBabyForm = null;

        if (enrollBaby.value.includes('other')) {
          applyOtherBabyForm = {
            baby_name: form.otherBabyName,
            due_date: form.otherBabyPredictBirthDate,
            birthday: form.otherBabyBirthday,
            hospital: form.otherBabyHospital,
            week: form.otherBabyBornWeek,
            weight_gm: form.otherBabyBornWeight,
          };
        }

        const payload = {
          uuid: route.query.id,
          babys: [...enrollBabyList, applyOtherBabyForm].filter((item) => item),
          phone: form.mobile,
          time: form.contactTime[0],
          adult: form.adult,
          child: form.children,
          remark: form.memo,
          name: memberInfo.value.realname,
          email: memberInfo.value.email,
        };

        const { status, message } = await parentApplyAPI(payload);
        if (status) {
          asyncDialog({
            render: ApplySuccess,
            callback: () => {
              router.push({ name: 'activity-lessons' });
            },
            extraFunc: () => {
              router.push({ name: 'apply' });
            },
          });
        } else {
          asyncDialog({
            desc: message,
          });
        }
      } catch (e) {
        console.log('e...', e);
      }
    };

    const toPreviousPage = () => {
      router.push({
        name: 'activity-lesson',
        query: {
          id: route.query.id,
        },
      });
    };

    watch(
      () => siteStore.memberInfo.babys,
      (newVal) => {
        if (newVal) {
          babyBriefOptions.value = newVal
            .map((baby) => ({
              label: baby.realname,
              value: baby.id,
              renderContent: h(BabyBrief, {
                babyInfo: baby,
              }),
            }))
            .concat({
              label: '其他早產兒寶寶',
              value: 'other',
            });

          if (babyBriefOptions.value.length === 1) {
            enrollBaby.value = ['other'];
          }

          babyIdDataMapping.value = newVal.reduce((obj, baby) => {
            obj[baby.id] = {
              baby_name: baby.realname,
              due_date: baby.due_date,
              birthday: baby.birthday,
              hospital: baby.hospital?.name || baby.hospital_name || '',
              week: baby.week,
              weight_gm: baby.weight_gm,
            };

            return obj;
          }, {});
        }
      },
      { immediate: true, deep: true },
    );

    const showOtherBabyField = computed(() => enrollBaby.value.includes('other'));

    // watch(
    //   enrollBaby,
    //   () => {
    //     console.log('enrollBaby...', enrollBaby.value);
    //   },
    //   { deep: true },
    // );

    watch(response, () => {
      getIndexEvents(response);
    });

    return {
      memberInfo,
      lessonData,
      identificationMapping,
      schema,
      form,
      contactTimeOptions,
      babyBriefOptions,
      enrollBaby,
      // handleSubmit,
      toPreviousPage,
      onSubmit,
      showOtherBabyField,
      onOtherBabbySubmit,
      // applyOtherBabyForm,
      dateInputFormat,
      isDisabled,
    };
  },
});
</script>
<style lang="scss" scoped>
.story-title {
  @include font-style($c-main, 35, 500, 3.5px, 51px);
}

.parent {
  @include font-important();
}

.email {
  margin-top: 12px;
  @include font-important();

  &__text {
    @include font-normal();
  }
}

.select-baby {
  @include font-important();
  margin-top: 30px;

  &__multiple {
    @include font-normal($c-main, 14, normal, 0.9px);
  }
}

.to-page {
  margin-top: 10px;
  @include flex(flex-end);

  &__previous {
    @include font-normal();
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
